<template>
    <div class="message-text-container">
        <form method="post">
            <div v-show="showEmojis" style="position: absolute; bottom: 0px; right: 42px;">
                <VEmojiPicker @select="selectEmoji"></VEmojiPicker>
            </div>
            <textarea
                @click="showEmojis = false "
                @keypress.enter.prevent="sendMessage"
                v-model="text"
                class="send-message"
                @keypress="whisper"
                :disabled="canNotSendMessage"
            ></textarea>
            <button @click.prevent="sendMessage" class="send-button" :disabled="canNotSendMessage">
                <i v-if="text != ''" class="fa fa-paper-plane text-info"></i>
                <i v-else class="fa fa-paper-plane"></i>
            </button>
            <button @click.prevent="showEmojis = !showEmojis" class="emoji-button" :disabled="canNotSendMessage">
                <i class="fa fa-meh text-info"></i>
            </button>
        </form>
    </div>
</template>

<script>
    import VEmojiPicker from 'v-emoji-picker';

    export default {
        name: "send-box",

        components: {
            VEmojiPicker
        },

        props: [
            'chatId',
            'userId',
            'canNotSendMessage'
        ],

        data() {
            return {
                text: '',
                showEmojis: false
            };
        },

        methods: {
            whisper() {
                if (echoEnabled) {
                    Echo.private("users." + this.userId)
                        .whisper("UserTyping", {user_id: this.userId});
                }
            },
            selectEmoji(emoji) {
                this.text = this.text + emoji.data;
            },
            sendMessage() {
                if (!this.text.length) {
                    return;
                }

                this.isLoading = true;

                let data = {
                    message: this.text,
                    chat_id: this.chatId,
                    type: 0 // for text messages
                };

                axios.post('/en/dashboard/messages', data)
                    .then((response) => {
                        Bus.$emit('MessageCreated', response.data.data)
                        this.text = ''
                    })
                    .catch(error => {
                        console.log(error.data);
                        if (error.response.data.type && error.response.data.type === 'canFeatureValidation') {
                            this.$toast.error(error.response.data.msg, {
                                queue: true
                            });
                        }
                        if (error.response.data.type && error.response.data.type === 'messageValidation') {
                            this.$toast.error(error.response.data.msg, {
                                queue: true
                            });
                        }
                    });

                this.isLoading = false;
            },
        },
    }
</script>

<style scoped>
    .message-text-container {
        position: relative;
    }

    .send-message {
        padding: 15px 85px 10px 30px;
    }

    .send-button {
        position: absolute;
        bottom: 5px;
        right: 15px;
    }

    .emoji-button {
        position: absolute;
        bottom: 5px;
        right: 48px;
    }
</style>
